import React from "react";
import "../../css/Fonts.css";
import * as Dialog from "@radix-ui/react-dialog";
import { Exclamation } from "../../icons/Exclamation";

// Modal component for logout confirmation
const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-white bg-opacity-85 z-50" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-[#4F5B6C40] shadow-lg w-[420px] mx-4 overflow-hidden z-50">
          {/* Header */}
          <div className="bg-[#0832DE] py-6">
            <Dialog.Title className="text-center logout-modal-title">
              Logout
            </Dialog.Title>
          </div>

          {/* Content */}
          <div>
            <div className="flex flex-row items-center gap-x-3 text-gray-500 m-6 mx-6">
              <div className="px-1.5">
                <Exclamation className="w-6 h-6 flex-shrink-0 self-center" />
              </div>
              <Dialog.Description className="text-xs flex-1 leading-tight">
                Вы действительно желаете выйти со своего аккаунта?
              </Dialog.Description>
            </div>

            {/* Buttons */}
            <div className="justify-center flex space-x-4 mb-6">
              <Dialog.Close asChild>
                <button
                  onClick={onClose}
                  className="rounded-md w-[140px] h-[40px] logout-modal-cancel-button"
                >
                  Отмена
                </button>
              </Dialog.Close>
              <button
                onClick={() => {
                  onConfirm();
                  onClose();
                }}
                className="rounded-md w-[140px] h-[40px] logout-modal-confirm-button"
              >
                Выйти
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
export default LogoutModal;
